// import { Divider } from "@aws-amplify/ui-react";
import {
	EqualizerOutlined,
	KeyboardArrowDownOutlined,
	KeyboardArrowUpOutlined,
	MailOutlined,
	NorthEastOutlined,
	PhoneOutlined,
	RefreshOutlined,
	SouthEastOutlined,
	TextsmsOutlined,
	TimelapseOutlined
} from "@mui/icons-material";
import {
	Box,
	Button,
	Card,
	CardContent,
	CardHeader,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Divider,
	IconButton,
	LinearProgress,
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableRow,
	ToggleButton,
	ToggleButtonGroup,
	Tooltip,
	Typography
} from '@mui/material';
import { BarChart, Gauge, PieChart } from "@mui/x-charts";
import { generateClient, post } from "aws-amplify/api";
import { fetchAuthSession } from "aws-amplify/auth";
import moment from "moment";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../../contexts/UserContext";
import { esQuery } from "../../graphql/queries";
import { actionOneButtonStyle, actionTwoButtonStyle, cardStyle } from "../../theme";
import ActiveCalls from "./activeCalls";
import CallBacks from "./callBacks";
import CampaignCallDetailsDialog from "./campaignCallDetails";
import CampaignStatusBreakdown from "./campaignStatusBreakdown";
import CampaignCallSuppressDialog from "./campaignSuppressionDetails";
import PenetrationDialog from "./penetrationDialog";
import SegmentPenetrationBreakdown from "./segmentPenetrationBreakdown";


const CampaignStatus = function (props) {
	const client = generateClient();
	const userContext = useContext(UserContext);
	const [campaignStatus, setCampaignStatus] = useState();
	const [channel, setChannel] = useState("voice");

	const [totalContacts, setTotalContacts] = useState();
	const [completedContacts, setCompletedContacts] = useState();
	const [percentageComplete, setPercentageComplete] = useState();
	const [activeCalls, setActiveCalls] = useState();
	const [callsInProgress, setCallsInProgress] = useState(0);

	const [dispositionCount, setDispositionCount] = useState(0);
	const [callBackCount, setCallBackCount] = useState(0);

	const [todayCalls, setTodayCalls] = useState(0);
	const [callDiff, setCallDiff] = useState(0);

	const [todaySuppressed, setTodaySuppressed] = useState(0);
	const [suppressedData, setSuppressedData] = useState();

	const [showBreakdown, setShowBreakdown] = useState(false);
	const [showSegmentPenetration, setShowSegmentPenetration] = useState(false);
	const [breakdownId, setBreakdownId] = useState();
	const [breakdownName, setBreakdownName] = useState();

	const [showPriority, setShowPriority] = useState(false);
	const [showCallDetails, setShowCallDetails] = useState(false);
	const [showSuppressDetails, setShowSuppressDetails] = useState(false);

	const [showActiveCalls, setShowActiveCalls] = useState(false);
	const [showCallBacks, setShowCallBacks] = useState(false);

	const [rawDispoData, setRawDispoData] = useState();
	const [refreshTime, setRefreshTime] = useState();

	const systemAgents = ['0000000', 'System', 'SS Service']

	const [systemRetryDispositions, setSystemRetryDispositions] = useState();
	const [systemRetryDispoCount, setSystemRetryDispoCount] = useState(0);
	const [systemFinalizedDispositions, setSystemFinalizedDispositions] = useState();
	const [systemFinalizedDispoCount, setSystemFinalizedDispoCount] = useState(0);
	const [agentRetryDispositions, setAgentRetryDispositions] = useState();
	const [agentRetryDispoCount, setAgentRetryDispoCount] = useState(0);
	const [agentFinalizedDispositions, setAgentFinalizedDispositions] = useState();
	const [agentFinalizedDispoCount, setAgentFinalizedDispoCount] = useState(0);

	const [agentDetails, setAgentDetails] = useState([]);

	const [freshCount, setFreshCount] = useState(0);

	const [approveCount, setApproveCount] = useState(0);
	const [recycleCount, setRecycleCount] = useState(0);
	const [outOfCurfewCount, setOutOfCurfewCount] = useState(0);
	const [outOfCallWindowCount, setOutOfCallWindowCount] = useState(0);

	const [showScheduledFresh, setShowScheduledFresh] = useState(false);

	useEffect(() => {
		//If there is configuration for the export SFTP then allow it as an action.
		if (props.campaign) {
			// console.log(props.campaign);
			getCampaignStatus();
			const interval = setInterval(() => {
				getCampaignStatus();
			}, 30000);
			return () => clearInterval(interval);
		}
	}, [props.campaign]);

	function getCallHistoryQuery(campaignId, startTime, endTime) {
		return {
			"aggs": {
				"status": {
					"terms": {
						"field": "contactStatus.keyword",
						"size": 2147483647
					},
					"aggs": {
						"disposition": {
							"terms": {
								"field": "disposition.keyword",
								"size": 2147483647
							},
							"aggs": {
								"agent": {
									"terms": {
										"field": "agent.keyword",
										"size": 2147483647
									}
								}
							}
						}
					}
				}
			},
			"query": {
				"bool": {
					"must": [
						{
							"term": {
								"tenant.keyword": userContext.tenantId
							}
						},
						{
							"match_phrase": {
								"type": "Dial"
							}
						},
						{
							"match_phrase": {
								"activityLogCampaignId": campaignId
							}
						},
						{
							"range": {
								"createdAt": {
									"gte": startTime,
									"lte": endTime
								}
							}
						}
					],
					"must_not": [
						{
							"match_phrase": {
								"disposition": "Cadence Exhaustion - Retry Increment"
							}
						}
					]
				}
			},
			"track_total_hits": true,
			"size": 0
		}
	}

	function getCallsSuppressedQuery(campaignId, startTime, endTime, aggField) {
		return {
			"aggs": {
				"suppressions": {
					"terms": {
						"field": aggField,
						"size": 2147483647
					}
				}
			},
			"query": {
				"bool": {
					"must": [
						{
							"term": {
								"tenant.keyword": userContext.tenantId
							}
						},
						{
							"match_phrase": {
								"type": "DialSuppress"
							}
						},
						{
							"match_phrase": {
								"activityLogCampaignId": campaignId
							}
						},
						{
							"range": {
								"createdAt": {
									"gte": startTime,
									"lte": endTime
								}
							}
						}
					]
				}
			},
			"track_total_hits": true,
			"size": 0
		}
	}

	function getApprovalAndRecycleQuery(campaignId, startTime, endTime) {
		return {
			"aggs": {
				"type": {
					"terms": {
						"field": "type.keyword",
						"size": 2147483647
					}
				}
			},
			"query": {
				"bool": {
					"must": [
						{
							"bool": {
								"should": [
									{
										"match": {
											"type": "DialRecycle"
										}
									},
									{
										"match": {
											"type": "DialApprove"
										}
									}
								]
							}
						},
						{
							"term": {
								"tenant.keyword": userContext.tenantId
							}
						},
						{
							"match_phrase": {
								"activityLogCampaignId": campaignId
							}
						},
						{
							"range": {
								"createdAt": {
									"gte": startTime,
									"lte": endTime
								}
							}
						}
					]
				}
			},
			"track_total_hits": true,
			"size": 0
		}
	}


	async function getCampaignCallHistory(campaignId) {
		try {
			let promises = [];
			promises.push(client.graphql({
				query: esQuery,
				variables: {
					model: 'activitylog-*',
					action: '_search',
					query: JSON.stringify(getCallHistoryQuery(campaignId, moment().startOf('day').toISOString(), moment().toISOString())),
				},
			}));
			promises.push(client.graphql({
				query: esQuery,
				variables: {
					model: 'activitylog-*',
					action: '_search',
					query: JSON.stringify(getCallHistoryQuery(campaignId, moment().startOf('day').subtract(1, 'days').toISOString(), moment().subtract(1, 'days').toISOString())),
				},
			}));
			promises.push(client.graphql({
				query: esQuery,
				variables: {
					model: 'activitylog-*',
					action: '_search',
					query: JSON.stringify(getCallsSuppressedQuery(campaignId, moment().startOf('day').toISOString(), moment().toISOString(), "metaData.dispDescription.keyword")),
				},
			}));
			promises.push(client.graphql({
				query: esQuery,
				variables: {
					model: 'activitylog-*',
					action: '_search',
					query: JSON.stringify(getApprovalAndRecycleQuery(campaignId, moment().startOf('day').toISOString(), moment().toISOString())),
				},
			}));



			const data = await Promise.all(promises);
			const today = JSON.parse(data[0].data.esQuery);
			const yesterday = JSON.parse(data[1].data.esQuery);
			const diff = today.hits.total.value - yesterday.hits.total.value;

			const suppressedOne = JSON.parse(data[2].data.esQuery);

			setTodayCalls(today.hits.total.value);
			setCallDiff(diff);
			setRawDispoData(today);

			// Set the out of curfew data and then remove the bucket from suppressedOne Data
			const curfewCount = suppressedOne.aggregations.suppressions.buckets.find(bucket => bucket.key === 'The contact was outside the specified curfew bounds and will be retried.')?.doc_count || 0;
			setOutOfCurfewCount(curfewCount);
			suppressedOne.aggregations.suppressions.buckets = suppressedOne.aggregations.suppressions.buckets.filter(bucket => bucket.key !== 'The contact was outside the specified curfew bounds and will be retried.');
			// Set the out of call window data and then remove the bucket from suppressedOne Data
			const callWindowCount = suppressedOne.aggregations.suppressions.buckets.find(bucket => bucket.key === 'The contact was outside the specified call window bounds for the point of contact.')?.doc_count || 0;
			setOutOfCallWindowCount(callWindowCount);
			suppressedOne.aggregations.suppressions.buckets = suppressedOne.aggregations.suppressions.buckets.filter(bucket => bucket.key !== 'The contact was outside the specified call window bounds for the point of contact.');

			setTodaySuppressed(suppressedOne.hits.total.value - curfewCount - callWindowCount);

			setSuppressedData([...suppressedOne.aggregations.suppressions.buckets]);

			const aggregatedAgentData = [];
			if (today?.aggregations?.status?.buckets) {
				for (const status of today.aggregations.status.buckets) {
					const systemDispositions = [];
					const agentDispositions = [];
					let systemTotalCount = 0;
					let agentTotalCount = 0;
					for (const disposition of status.disposition.buckets) {
						if (disposition.agent.buckets) {
							let agentCount = 0;
							let systemCount = 0;
							for (const agent of disposition.agent.buckets) {
								if (systemAgents.includes(agent.key)) {
									systemCount = systemCount + agent.doc_count;
									systemTotalCount = systemTotalCount + agent.doc_count;
								} else {
									agentCount = agentCount + agent.doc_count;
									// Aggregate agent data for display
									const existingAgent = aggregatedAgentData.find(a => a.agent === agent.key);
									if (existingAgent) {
										existingAgent.count += agent.doc_count;
										existingAgent.dispositions.push({ disposition, count: agent.doc_count });
									} else {
										aggregatedAgentData.push({ agent: agent.key, count: agent.doc_count, dispositions: [{disposition, count: agent.doc_count}] });
									}
									agentTotalCount = agentTotalCount + agent.doc_count;
								}
							}
							if (systemCount > 0) {
								systemDispositions.push({ label: disposition.key, value: systemCount });
							}
							if (agentCount > 0) {
								agentDispositions.push({ label: disposition.key, value: agentCount });
							}
						}
					}
					if (status.key === 'completed') {
						// Sort from highest to lowest
						setSystemFinalizedDispoCount(systemTotalCount);
						setAgentFinalizedDispoCount(agentTotalCount);
						agentDispositions.sort((a, b) => b.value - a.value);
						systemDispositions.sort((a, b) => b.value - a.value);
						setSystemFinalizedDispositions(systemDispositions);
						setAgentFinalizedDispositions(agentDispositions);
					} else {
						// Sort from highest to lowest
						setSystemRetryDispoCount(systemTotalCount);
						setAgentRetryDispoCount(agentTotalCount);
						agentDispositions.sort((a, b) => b.value - a.value);
						systemDispositions.sort((a, b) => b.value - a.value);
						setSystemRetryDispositions(systemDispositions);
						setAgentRetryDispositions(agentDispositions);
					}
				}
			}

			setAgentDetails(aggregatedAgentData.sort((a, b) => b.count - a.count));
			const approvalAndRecycle = JSON.parse(data[3].data.esQuery);
			setApproveCount(approvalAndRecycle.aggregations.type.buckets.find(bucket => bucket.key === 'DialApprove')?.doc_count || 0);
			setRecycleCount(approvalAndRecycle.aggregations.type.buckets.find(bucket => bucket.key === 'DialRecycle')?.doc_count || 0);



		} catch (error) {
			console.error(error);
		}
	}

	async function getCampaignStatus() {
		try {
			getCampaignCallHistory(props.campaign.id);
			setRefreshTime(new Date().toLocaleTimeString("en-US", { hour: '2-digit', minute: '2-digit', second: '2-digit' }));
			const data = await post({
				apiName: "cdyxoutreach",
				path: "/cache/status",
				options: {
					headers: {
						Authorization: `Bearer ${(await fetchAuthSession()).tokens.idToken}`,
						"x-api-key": userContext.apiKey,
					},
					body: {
						campaignId: props.campaign.id,
						channel: channel,
					},
				},
			}).response;

			const getData = await data.body.json();

			//Setting Retrieved Data
			setTotalContacts(getData.totalContacts);

			//CompletedContacts && totalFresh

			let totalFresh = 0;
			let completed = 0;
			let showPriority = false;
			for (const segment of getData.campaignStats) {
				completed = completed + segment.completed;
				totalFresh = totalFresh + segment.fresh + segment.priority;
				if (segment.priority > 0) {
					showPriority = true;
				}
			}
			setShowScheduledFresh(showPriority);
			setCompletedContacts(completed);
			setFreshCount(totalFresh);

			// CompletedPercentage
			let percentage = '-';
			if (getData.totalContacts > 0) {
				percentage = ((completed / getData.totalContacts) * 100).toFixed(0);
			}
			setPercentageComplete(percentage);
			setActiveCalls(getData.active ? getData.active : 0);
			setCallsInProgress(getData.inProgress ? getData.inProgress : 0);

			setCallBackCount(getData.callBacks ? getData.callBacks : 0);
			setDispositionCount(getData.dispositioning ? getData.dispositioning : 0);
			setCampaignStatus([...getData.campaignStats]);
		} catch (err) {
			console.error(err);
		}
	}

	const toggleChannel = (event, value) => {
		if (value) {
			setChannel(value);
		}
	};

	function GetRow({agent}) {
		const [open, setOpen] = useState(false);

		return (
			<>
			<TableRow key={agent.agent} onClick={() => {
				setOpen(!open);
			}}>
				<TableCell>{open ? <KeyboardArrowUpOutlined /> : <KeyboardArrowDownOutlined />}</TableCell>
				<TableCell>
					{agent.agent}
				</TableCell>
				<TableCell align="right">{agent.count}</TableCell>
				<TableCell align="right">{((agent.count / (agentFinalizedDispoCount + agentRetryDispoCount)) * 100).toFixed(2)}%</TableCell>
			</TableRow>
			<TableRow sx={{ display: open ? 'table-row' : 'none' }}>
				<TableCell colSpan={4} sx={{ paddingBottom: 0, paddingTop: 0 }}>
					<Table size="small" aria-label="dispositions">
						<TableHead>
							<TableRow>
								<TableCell>Disposition</TableCell>
								<TableCell align="right">Count</TableCell>
								<TableCell align="right">Percentage</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{agent.dispositions.map((disposition) => (
								<TableRow key={disposition.disposition.key}>
									<TableCell>
										{disposition.disposition.key}
									</TableCell>
									<TableCell align="right">{disposition.count}</TableCell>
									<TableCell align="right">{((disposition.count / agent.count) * 100).toFixed(2)}%</TableCell>
									</TableRow>
							))}
						</TableBody>
					</Table>
				</TableCell>
			</TableRow>
			</>
		);
	}



	return (
		<>
			{campaignStatus && <Box display="flex" flexDirection="column" gap={4}>
				<Box display="grid" gridTemplateColumns="2fr 1fr" gap={4} alignItems="stretch">
					<Card variant="outlined"
						sx={{
							height: '100%',
							backgroundColor: 'primary.light',
							borderRadius: '20px',
						}}
					>
						<Box display="flex" flexDirection="column" gap={2} sx={{ padding: 2 }}>
							<Box display="flex" justifyContent="space-between">
								<Typography variant="h5">{props.campaign.name}</Typography>
								<Box display="flex" alignItems="center" gap={1}>
									<Typography variant="subtitle2">{refreshTime}</Typography>
									<Tooltip title="Refresh"><IconButton onClick={() => getCampaignStatus()}><RefreshOutlined color="primary" /></IconButton></Tooltip>
								</Box>
							</Box>
							<Box display="flex" justifyContent="space-between" alignItems="center">
								<Box display="flex" flexDirection="column" justifyContent="space-between" gap={2}>
									<Box display="flex" gap={2}>
										<Box display="flex" flexDirection="column" alignItems="center" >
											<Typography variant="h2">{todayCalls}</Typography>
											<Box display="flex" flexDirection="column" alignItems="center">
												<Typography variant="h6">Calls Today</Typography>
												<Button sx={actionOneButtonStyle} onClick={() => setShowPriority(true)}>View Penetration</Button>
											</Box>
										</Box>
										<Divider orientation="vertical" flexItem />
										<Box display="flex" flexDirection="column" alignItems="center">
											<Box display="flex" alignItems="center" gap={1}>
												{/* {!isNaN(callDiff) && isFinite(callDiff) && <Typography variant="h4">{`${callDiff.toFixed(0)}%`}</Typography>} */}
												<Typography color="white" variant="h2">{callDiff}</Typography>
												{callDiff > 0 && <NorthEastOutlined color="primary" />}
												{callDiff < 0 && <SouthEastOutlined color="primary" />}
											</Box>
											<Box display="flex" flexDirection="column" alignItems="center">
												<Typography color="white" variant="h6">From Yesterday</Typography>
												<Typography color="white" variant="subtitle2">At this time</Typography>
											</Box>

										</Box>
									</Box>
								</Box>
								<Box display="flex" flexDirection="column" alignItems="center" >
									<Gauge
										width={150}
										height={150}
										value={percentageComplete}
										startAngle={0}
										endAngle={360}
										innerRadius="70%"
										outerRadius="100%"
										text={`${completedContacts} / ${totalContacts}`}
									/>
									<Typography color="white" variant="subtitle2">Contacts Completed</Typography>
								</Box>
							</Box>
						</Box>
					</Card>
					<Box display="grid" gridTemplateColumns="1fr 1fr" gap={4}>
						<Card variant="outlined" sx={cardStyle}>
							<CardHeader title="Agent - Final" subheader="Today" />
							<CardContent sx={{ justifyContent: 'center', alignItems: 'center' }}>
								<Box display="flex" justifyContent="center" alignItems="center">
									<Box sx={{ width: 100 }}>
										<PieChart
											height={100}
											slotProps={{ legend: { hidden: true } }}
											series={[
												{
													// Agent Finalized Dispositions
													data: agentFinalizedDispositions ? agentFinalizedDispositions : [],
													innerRadius: 25,
													outerRadius: 50,
													paddingAngle: 2,
													cornerRadius: 5,
													cx: 45
												}
											]}
										/>
									</Box>
								</Box>
							</CardContent>
						</Card>

						<Card variant="outlined" sx={cardStyle}>
							<CardHeader title="System - Final" subheader="Today" />
							<CardContent>
								<Box display="flex" justifyContent="center" alignItems="center">
									<Box sx={{ width: 100 }}>
										<PieChart
											height={100}
											slotProps={{ legend: { hidden: true } }}
											series={[
												{
													//System Finalized Dispositions
													data: systemFinalizedDispositions ? systemFinalizedDispositions : [],
													innerRadius: 25,
													outerRadius: 50,
													paddingAngle: 2,
													cornerRadius: 5,
													cx: 45
												}
											]}
										/>
									</Box>
								</Box>
							</CardContent>
						</Card>
					</Box>
				</Box>
				<Box display="grid" gridTemplateColumns="2fr 1fr" gap={4} alignItems="stretch">
					<Box display="grid" gridTemplateColumns="1fr 1fr" gap={4}>
						<Box display="grid" gridTemplateColumns="1fr 1fr" gap={4}>
							<Card variant="outlined" sx={cardStyle}>
								<Box display="flex" sx={{ height: '100%' }} justifyContent="center" flexDirection="column" alignItems="center" >
									<Typography variant="h2">{callsInProgress - activeCalls - dispositionCount > 0 ? callsInProgress - activeCalls - dispositionCount : 0}</Typography>
									<Typography variant="h6">Calls in Progress</Typography>
								</Box>
							</Card>
							<Card variant="outlined" sx={cardStyle}>
								<Box display="flex" sx={{ height: '100%' }} flexDirection="column" alignItems="center" justifyContent="center" >
									<Typography variant="h2">{activeCalls}</Typography>
									<Typography variant="h6">Active Calls</Typography>
									<Button disabled={activeCalls < 1} onClick={() => setShowActiveCalls(true)}>View Calls</Button>
								</Box>
							</Card>

							{userContext.telephonyProvider === 'NiC' && <Card variant="outlined" sx={cardStyle}>
								<Box display="flex" sx={{ height: '100%' }} justifyContent="center" flexDirection="column" alignItems="center" >
									<Typography variant="h2">{dispositionCount}</Typography>
									<Typography variant="h6">Dispositioning</Typography>
								</Box>
							</Card>}

							<Card
								variant="outlined"
								sx={cardStyle}
							>
								<Box display="flex" sx={{ height: '100%' }} flexDirection="column" alignItems="center" justifyContent="center" >
									<Typography variant="h2">{todaySuppressed}</Typography>
									<Typography variant="h6">Suppressions</Typography>
									<Button disabled={todaySuppressed < 1} onClick={() => setShowSuppressDetails(true)}>View Details</Button>
								</Box>
							</Card>

							{userContext.telephonyProvider === 'Webex' && <Card variant="outlined" sx={cardStyle}>
								<Box display="flex" sx={{ height: '100%' }} justifyContent="center" flexDirection="column" alignItems="center" >
									<Typography variant="h2">{callBackCount}</Typography>
									<Typography variant="h6">Call Backs</Typography>
									<Button disabled={callBackCount < 1} onClick={() => setShowCallBacks(true)}>View Call Backs</Button>
								</Box>
							</Card>}
						</Box>
						<Card variant='outlined' sx={cardStyle}>
							<CardHeader title="Campaign Events" subheader="Today" />
							<CardContent>
								<Box display="flex" flexDirection="column" gap={2}>
									{!props.campaign.autoMode &&<BarChart
										series={[
											{ data: [approveCount], label: 'Approved', stack: '1' },
											{ data: [callsInProgress], label: 'In Progress', stack: '2' },
											{ data: [recycleCount], label: 'Recycled', stack: '2' },
											{ data: [todayCalls], label: 'Calls', stack: '2' }
										]}
										slotProps={{ legend: { hidden: true } }}
										height={200}
										hideLegend={true}
										borderRadius={6}
										xAxis={[{ data: ['Today'], scaleType: 'band' }]}
									/>}
									<Table size="small">
										<TableBody>
											{!props.campaign.autoMode && <TableRow>
												<TableCell>
													Dials Approved
												</TableCell>
												<TableCell align="right">
													<Typography variant="h6">{approveCount}</Typography>
												</TableCell>
											</TableRow>}
											{!props.campaign.autoMode && <TableRow>
												<TableCell>
													Dials Recycled
												</TableCell>
												<TableCell align="right">
													<Tooltip title="Recycled contacts were either recycled manually by the approver or automatically by the system if there were more approvals than allowed by the dialing ratio.">
														<Typography variant="h6">{recycleCount}</Typography>
													</Tooltip>
												</TableCell>
											</TableRow>}
											<TableRow>
												<TableCell>
													Out of Curfew
												</TableCell>
												<TableCell align="right">
													<Typography variant="h6">{outOfCurfewCount}</Typography>
												</TableCell>
											</TableRow>
											<TableRow>
												<TableCell>
													Out of Call Window
												</TableCell>
												<TableCell align="right">
													<Typography variant="h6">{outOfCallWindowCount}</Typography>
												</TableCell>
											</TableRow>
										</TableBody>
									</Table>
								</Box>
							</CardContent>
						</Card>
					</Box>
					<Box display="flex" flexDirection="column" gap={4}>
						<Box display="grid" gridTemplateColumns="1fr 1fr" gap={4}>
							<Card variant="outlined" sx={cardStyle}>
								<CardHeader title="Agent - Retry" subheader="Today" />
								<CardContent>
									<Box display="flex" justifyContent="center" alignItems="center">
										<Box sx={{ width: 100 }}>
											<PieChart
												height={100}
												slotProps={{ legend: { hidden: true } }}
												series={[
													{
														// Agent Retry Dispositions
														data: agentRetryDispositions ? agentRetryDispositions : [],
														innerRadius: 25,
														outerRadius: 50,
														paddingAngle: 2,
														cornerRadius: 5,
														cx: 45
													}
												]}
											/>
										</Box>
									</Box>
								</CardContent>
							</Card>

							<Card variant="outlined" sx={cardStyle}>
								<CardHeader title="System - Retry" subheader="Today" />
								<CardContent>
									<Box display="flex" justifyContent="center" alignItems="center">
										<Box sx={{ width: 100 }}>
											<PieChart
												height={100}
												slotProps={{ legend: { hidden: true } }}
												series={[
													{
														//System Retry Dispositions
														data: systemRetryDispositions ? systemRetryDispositions : [],
														innerRadius: 25,
														outerRadius: 50,
														paddingAngle: 2,
														cornerRadius: 5,
														cx: 45
													}
												]}
											/>
										</Box>
									</Box>
								</CardContent>
							</Card>
						</Box>
						<Card variant="outlined" sx={cardStyle}>
							<CardHeader title="Category Counts" subheader="Today" action={<Button sx={actionOneButtonStyle} onClick={() => setShowCallDetails(true)}>View Call Details</Button>} />
							<CardContent>
								<Table size="small">
									<TableBody>
										<TableRow>
											<TableCell>Agent Finalized</TableCell>
											<TableCell align="right">{agentFinalizedDispoCount}</TableCell>
										</TableRow>
										<TableRow>
											<TableCell>System Finalized</TableCell>
											<TableCell align="right">{systemFinalizedDispoCount}</TableCell>
										</TableRow>
										<TableRow>
											<TableCell>Agent Retry</TableCell>
											<TableCell align="right">{agentRetryDispoCount}</TableCell>
										</TableRow>
										<TableRow>
											<TableCell>System Retry</TableCell>
											<TableCell align="right">{systemRetryDispoCount}</TableCell>
										</TableRow>
									</TableBody>
								</Table>
							</CardContent>
						</Card>
					</Box>
				</Box>


				{/* Second row */}
				<Box display="grid" gridTemplateColumns="1fr 1fr" gap={4}>
					<Card variant="outlined" sx={cardStyle}>
						<CardHeader title="Agent Details" subheader="Today" />
						<CardContent>
							<Table size="small">
								<TableHead>
									<TableRow>
										<TableCell></TableCell>
										<TableCell>Agent</TableCell>
										<TableCell align="right">Count</TableCell>
										<TableCell align="right">Percentage</TableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									{agentDetails.map((agent) => (
										<GetRow agent={agent} />
									))}
								</TableBody>
							</Table>
						</CardContent>
					</Card>
					{!showBreakdown && !showSegmentPenetration && <Box >
						<Card variant="outlined" sx={{ ...cardStyle, height: '100%' }}>
							<CardHeader title={
								<Box display="flex" justifyContent="space-between">
									<Typography variant="h5">Inventory</Typography>
									<ToggleButtonGroup
										size="small"
										value={channel}
										exclusive
										onChange={toggleChannel}
									>
										<ToggleButton value="voice">
											<Tooltip title="View Voice Inventory">
												<PhoneOutlined color="primary" fontSize="small" />
											</Tooltip>
										</ToggleButton>
										<ToggleButton value="sms">
											<Tooltip title="View SMS Inventory">
												<TextsmsOutlined color="primary" fontSize="small" />
											</Tooltip>
										</ToggleButton>
										<ToggleButton value="email">
											<Tooltip title="View Email Inventory">
												<MailOutlined color="primary" fontSize="small" />
											</Tooltip>
										</ToggleButton>
									</ToggleButtonGroup>
								</Box>
							} />
							<CardContent>
								{campaignStatus && channel === "voice" && (
									<Box>
										<Table>
											<TableHead>
												<TableRow>
													<TableCell><Typography variant="h6">Segment</Typography></TableCell>
													{showScheduledFresh && <TableCell align="center">
														<Box display="flex" flexDirection="column" alignItems="center">
															<Typography variant="h6">Scheduled Fresh</Typography>
															<Typography variant="subtitle2">Available / Total</Typography>
														</Box>
													</TableCell>}
													<TableCell align="center">
														<Box display="flex" flexDirection="column" alignItems="center">
															<Typography variant="h6">Fresh</Typography>
															<Typography variant="subtitle2">Available / Total</Typography>
														</Box>
													</TableCell>
													<TableCell align="center">
														<Box display="flex" flexDirection="column" alignItems="center">
															<Typography variant="h6">Retry</Typography>
															<Typography variant="subtitle2">Available / Total</Typography>
														</Box>
													</TableCell>
													<TableCell align="center">
														<Typography variant="h6">Details</Typography>
													</TableCell>
												</TableRow>
											</TableHead>
											<TableBody>
												{campaignStatus.map((row) => (
													<TableRow key={row.segment}>
														<TableCell component="th" scope="row">
															<Typography variant="h6">{row.segment}</Typography>
														</TableCell>
														{showScheduledFresh && <TableCell align="center"><Typography variant="h6">{`${row.priorityAvailable} / ${row.priority}`}</Typography></TableCell>}
														<TableCell align="center"><Typography variant="h6">{`${row.availableFresh} / ${row.fresh}`}</Typography></TableCell>
														<TableCell align="center"><Typography variant="h6">{`${row.readyRetry} / ${row.retry}`}</Typography></TableCell>
														<TableCell>
															<Box display="flex" justifyContent="center" alignItems="center" gap={1}>
																<Tooltip title="Contact Availability">
																	<IconButton onClick={() => {
																		setShowBreakdown(true)
																		setBreakdownId(row.segmentId)
																		setBreakdownName(row.segment)
																	}}><TimelapseOutlined color="primary" />
																	</IconButton>
																</Tooltip>
																<Tooltip title="Penetration Details">
																	<IconButton onClick={() => {
																		setShowSegmentPenetration(true)
																		setBreakdownId(row.segmentId)
																		setBreakdownName(row.segment)
																	}}><EqualizerOutlined color="primary" />
																	</IconButton>
																</Tooltip>
															</Box>

														</TableCell>
													</TableRow>
												))}
											</TableBody>
										</Table>
									</Box>
								)}

								{campaignStatus && channel === "sms" && (
									<Box>
										<Table>
											<TableHead>
												<TableRow>
													<TableCell><Typography variant="h6">Segment</Typography></TableCell>
													<TableCell align="center">
														<Box display="flex" flexDirection="column" alignItems="center">
															<Typography variant="h6">Fresh</Typography>
															<Typography variant="subtitle2">Available / Total</Typography>
														</Box>
													</TableCell>
													<TableCell align="center">
														<Box display="flex" flexDirection="column" alignItems="center">
															<Typography variant="h6">Retry</Typography>
															<Typography variant="subtitle2">Available / Total</Typography>
														</Box>
													</TableCell>
													<TableCell align="center">
														<Typography variant="h6">Details</Typography>
													</TableCell>
												</TableRow>
											</TableHead>
											<TableBody>
												{campaignStatus.map((row) => (
													<TableRow key={row.segment}>
														<TableCell component="th" scope="row">
															<Typography variant="h6">{row.segment}</Typography>
														</TableCell>
														<TableCell align="center"><Typography variant="h6">{`${row.smsAvailableFresh} / ${row.smsFresh}`}</Typography></TableCell>
														<TableCell align="center"><Typography variant="h6">{`${row.smsReadyRetry} / ${row.smsRetry}`}</Typography></TableCell>
														<TableCell
															onClick={() => {
																setShowBreakdown(true)
																setBreakdownId(row.segmentId)
															}}
															align="center"
														>
															<EqualizerOutlined color="primary" />
														</TableCell>
													</TableRow>
												))}
											</TableBody>
										</Table>
									</Box>
								)}

								{campaignStatus && channel === "email" && (
									<Box>
										<Table>
											<TableHead>
												<TableRow>
													<TableCell><Typography variant="h6">Segment</Typography></TableCell>
													<TableCell align="center">
														<Box display="flex" flexDirection="column" alignItems="center">
															<Typography variant="h6">Fresh</Typography>
															<Typography variant="subtitle2">Available / Total</Typography>
														</Box>
													</TableCell>
													<TableCell align="center">
														<Box display="flex" flexDirection="column" alignItems="center">
															<Typography variant="h6">Retry</Typography>
															<Typography variant="subtitle2">Available / Total</Typography>
														</Box>
													</TableCell>
													<TableCell align="center">
														<Typography variant="h6">Details</Typography>
													</TableCell>
												</TableRow>
											</TableHead>
											<TableBody>
												{campaignStatus.map((row) => (
													<TableRow key={row.segment}>
														<TableCell component="th" scope="row">
															<Typography variant="h6">{row.segment}</Typography>
														</TableCell>
														<TableCell align="center"><Typography variant="h6">{`${row.emailAvailableFresh} / ${row.emailFresh}`}</Typography></TableCell>
														<TableCell align="center"><Typography variant="h6">{`${row.emailReadyRetry} / ${row.emailRetry}`}</Typography></TableCell>
														<TableCell
															onClick={() => {
																setShowBreakdown(true)
																setBreakdownId(row.segmentId)
															}}
															align="center"
														>
															<EqualizerOutlined color="primary" />
														</TableCell>
													</TableRow>
												))}
											</TableBody>
										</Table>
									</Box>
								)}

							</CardContent>
						</Card>
					</Box>}
					{showBreakdown && <Box>
						<CampaignStatusBreakdown
							campaignId={props.campaign.id}
							segmentId={breakdownId}
							channel={channel}
							setBreakdownId={setBreakdownId}
							setShowBreakdown={setShowBreakdown}
						/>
					</Box>}
					{showSegmentPenetration && <Box>
						<SegmentPenetrationBreakdown
							campaignId={props.campaign.id}
							segmentId={breakdownId}
							segmentName={breakdownName}
							channel={channel}
							setBreakdownId={setBreakdownId}
							setBreakdownName={setBreakdownName}
							setShowSegmentPenetration={setShowSegmentPenetration}
						/>
					</Box>}
				</Box>
			</Box>}

			{/* Dialogs */}

			{/* Penetration Dialog */}
			<Dialog open={showPriority} onClose={() => setShowPriority(false)} maxWidth="xl" >
				<DialogTitle>
					<Box display="flex" gap={2} alignItems="center">
						<Typography variant="h6">Today's Penetration Details</Typography>
					</Box>
				</DialogTitle>
				<DialogContent sx={{ padding: 3 }}>
					<PenetrationDialog
						open={showPriority}
						campaignId={props.campaign?.id}
						totalContacts={totalContacts}
						freshCount={freshCount}
						suppressCount={todaySuppressed}
						inputStartDate={moment().startOf('day').toISOString()}
						inputEndDate={moment().toISOString()}
					/>
				</DialogContent>
				<DialogActions>
					<Button sx={actionTwoButtonStyle} onClick={() => {
						setShowPriority(false)
						props.setCampaignStatusOpen(false);
						props.setCampaignHistoryOpen(true);
					}} color="primary">
						Historical
					</Button>
					<Button sx={actionTwoButtonStyle} onClick={() => setShowPriority(false)} color="primary">
						Close
					</Button>

				</DialogActions>
			</Dialog >

			{/* Call Details Dialog */}
			<Dialog open={showCallDetails} onClose={() => setShowCallDetails(false)} fullWidth maxWidth="xl">
				<DialogTitle>Disposition Details</DialogTitle>
				<DialogContent sx={{ padding: 3 }}>
					<CampaignCallDetailsDialog
						segments={JSON.parse(props.campaign?.segments)}
						open={showCallDetails}
						data={rawDispoData?.aggregations?.status?.buckets}
						inputStartDate={moment().startOf('day').toISOString()}
						inputEndDate={moment().toISOString()}
						campaignId={props.campaign?.id}
						campaignName={props.campaign?.name}
					/>
				</DialogContent>
				<DialogActions>
					<Button sx={actionTwoButtonStyle} onClick={() => setShowCallDetails(false)} color="primary">
						Close
					</Button>
				</DialogActions>
			</Dialog>

			{/* Call Suppression Details Dialog */}
			<Dialog open={showSuppressDetails} onClose={() => setShowSuppressDetails(false)} fullWidth maxWidth="xl">
				<DialogTitle>Supppression Details</DialogTitle>
				<DialogContent sx={{ padding: 3 }}>
					<CampaignCallSuppressDialog
						open={showSuppressDetails}
						data={suppressedData}
						totalSuppressionCount={todaySuppressed}
						campaignId={props.campaign?.id}
					/>
				</DialogContent>
				<DialogActions>
					<Button sx={actionTwoButtonStyle} onClick={() => setShowSuppressDetails(false)} color="primary">
						Close
					</Button>
				</DialogActions>
			</Dialog>

			{
				!campaignStatus && <Box display="flex" justifyContent="center" alignItems="center">
					<LinearProgress color="primary" />
				</Box>
			}
			<ActiveCalls
				open={showActiveCalls}
				onClose={() => setShowActiveCalls(false)}
				campaignId={props.campaign?.id}
				campaignName={props.campaign?.name}
			/>
			<CallBacks
				open={showCallBacks}
				onClose={() => setShowCallBacks(false)}
				campaignId={props.campaign?.id}
				campaignName={props.campaign?.name}
			/>
		</>
	);
};
export default CampaignStatus;
